import { Component, Input, input, output, Signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { CommonModule } from '@angular/common';
import DOMPurify from 'dompurify';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-admin-user-input',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    QuillModule, 
    MatButtonModule
  ],
  templateUrl: './admin-user-input.component.html',
  styleUrl: './admin-user-input.component.scss'
})
export class AdminUserInputComponent {

  @Input() editorContent!: string;
  readonly onEditorContentSaved = output<string>();

  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, false] }],
        //[{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'],                                         // remove formatting button
        ['link'],
        //['link', 'image', 'video'] 
      ],
      
    },
    // clipboard: {
    //   matchVisual: false, // Kopierter Text übernimmt kein Styling
    // },
    history: {
      delay: 2000, // Zeit für "Undo"
      maxStack: 100, // Maximale Undo/Redo-Schritte
    },
  }

  constructor() {}


  private sanitizeInput(html: string): string {
    return DOMPurify.sanitize(html); // Bereinigt HTML
    // this.sanitizer.bypassSecurityTrustHtml(content) as string;
  }

  public saveEditorContent(): void {
    const sanitizedHtml = this.addCustomClassToHTML(this.sanitizeInput(this.editorContent));
    this.onEditorContentSaved.emit(sanitizedHtml);
  }

  private addCustomClassToHTML(html: string): string {
    return html
        .replace(/&nbsp;/g, " ") 
        .replace(/<p>/g, "<p class='custom-body-medium'>") 
        .replace(/<h1>/g, "<h1 class='custom-display-large'>") 
        .replace(/<h2>/g, "<h2 class='custom-headline-medium'>")
        .replace(/<h3>/g, "<h3 class='custom-title-medium'>")
        .replace(/<h4>/g, "<h4 class='custom-title-large'>");
  }
}
